export default "__VITE_ASSET__DaT$j84f__"